const ExternalEscalations = () => {
  return (
    <div className="new-analytics-page--layout flex h-full items-center justify-center rounded-lg bg-primaryGray-16 p-4">
      <>
        <iframe
          title="External Escalations"
          width="100%"
          height="100%"
          src={
            "https://onerisa-escalations.web.app/?tab=escalations&mode=inbox&window=all"
          }
          allowFullScreen={true}
        ></iframe>
      </>
    </div>
  );
};

export default ExternalEscalations;
